import Axios from 'axios'
import { API_ADMIN } from '../../utils/constants/Api'

export default {
    getImageList(): Promise<string[]> {
        return Axios.get(`${API_ADMIN}images/tmp`)
            .then(({data}) => {
                return data;
            });
    },

    createImageList(imageList: string[]): Promise<string[]> {
        return Axios.post(`${API_ADMIN}images/tmp`, imageList)
            .then(({data}) => {
                return data;
            });
    },
}
